import React from "react";

interface IProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  animated?: boolean;
  register?: any;
  errorMessage?: string;
  children?: React.ReactNode;
}

export function Select({
  label,
  className = "mb-3",
  animated,
  register,
  errorMessage,
  children,
  ...rest
}: IProps) {
  const selectOptions = children || (
    <>
      <option value="">Selecione</option>
    </>
  );

    return (
        <>
            {animated &&
                <div className={`form-floating ${className}`}>
                    <select 
                        className={`form-select ${errorMessage ? 'is-invalid' : ''}`}                        
                        {...register}
                        {...rest}
                    >
                        {selectOptions}
                    </select>
                    <label>{label}</label>
                    {errorMessage &&
                        <div className="invalid-feedback">
                            {errorMessage}
                        </div>
                    }
                </div>
            }

            {!animated &&
                <div className={className}>
                    {label && <label className="form-label">{label}</label>}

                    <select 
                        className={`form-select ${errorMessage ? 'is-invalid' : ''}`}
                        aria-label={label || "Selecione"}
                        {...register}
                        {...rest}
                    >
                        {selectOptions}
                    </select>
                    {errorMessage &&
                        <div className="invalid-feedback">
                            {errorMessage}
                        </div>
                    }
                </div>
            }
        </>
    );
}
